import React, {createContext, useEffect, useState} from "react";
import useClient from "../hooks/useClient";

type SubmissionWindow = {
  forecast_month: string;
  window_status: string;
  window_opens: string;
  window_closes: string;
  current_fc: string;
  next_window_opens: string;
};

//use a default and very obviously wrong date, so we can see where it shows up in other calls
//To make it even more obvious, it's recommended we use a type of "Date|undefined"; this would require more
//updating of client code so leaving this alone until we can undergo a more thorough cleaning/refactoring.
const defaultDate = new Date(NaN);
export const DueDateContext = createContext<{
  isSubWindowLoading: Boolean;
  windowCloses: Date;
  currentFC: Date;
  shipmentMonthDate: Date;  //equivalent of forecastMonth on the backend
  windowOpens: Date;
  nextWindowOpens: Date;
  windowStatus: string;
}>({
  isSubWindowLoading: false,
  windowCloses: defaultDate,
  currentFC: defaultDate,
  shipmentMonthDate: new Date(),
  // ^Should be defaultDate but "Should see percentages across first row of table" fails in ShipmentMonthTables.test.tsx
  windowOpens: defaultDate,
  nextWindowOpens: defaultDate,
  windowStatus: "CLOSED"
});

export const DueDateProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { fetchWithAuth } = useClient();
  const [isSubWindowLoading, setIsSubWindowLoading] = useState(true);
  const [thirdBusinessDay, setThirdBusinessDay] = React.useState("");
  const [windowStatus, setWindowStatus] = React.useState("")
  const [windowOpens, setWindowOpens] = React.useState(defaultDate);
  const [windowCloses, setWindowCloses] = React.useState(defaultDate);
  const [currentFC, setCurrentFC] = React.useState(defaultDate);
  const [shipmentMonthDate, setShipmentMonthDate] = React.useState(defaultDate);
  const [nextWindowOpens, setNextWindowOpens] = React.useState(defaultDate);


  useEffect(() => {
    const callSubmissionWindow = async () => {
      return await fetchWithAuth<SubmissionWindow>(
        "/v1/landing/submission-window",
        (text: string) => console.warn(text),
      );
    };
    setIsSubWindowLoading(true);
    callSubmissionWindow().then((data) => {
        // forecast_month is in ISO format and we need to ensure Date constructor doesn't change to the previous day
        // when a new Date is constructed in local time zone so we advance it end of the first day.
        const forecastMonth = new Date(`${data.forecast_month}T23:59:59Z`);
        setShipmentMonthDate(forecastMonth);
        // The backend computes this for us, so we just grab currentFC
        const landingPageFC = new Date(currentFC);
        setCurrentFC(landingPageFC);
        setWindowStatus(data.window_status);
        setWindowCloses(new Date(data.window_closes));
        setWindowOpens(new Date(data.window_opens));
        setNextWindowOpens(new Date(data.next_window_opens));
        setIsSubWindowLoading(false);
    });
  }, []);
  return (
    <DueDateContext.Provider
      value={{ isSubWindowLoading, windowStatus, windowCloses, windowOpens, currentFC,
        shipmentMonthDate, nextWindowOpens }}
    >
      {children}
    </DueDateContext.Provider>
  );
};
